import React, { useEffect, useState } from "react";

const RandomProducts = ({clientName,language}) => {
  const [allProducts, setAllProducts] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [showMoreButton, setShowMoreButton] = useState(true);
  const [websiteUrl, setWebsiteUrl] = useState("");
  useEffect(() => {
    fetch(`/invoice/client/${clientName}/products/products.json`)
      .then(response => response.json())
      .then(data => {
        setWebsiteUrl(data.config.website_url);
        const shuffled = data.products.sort(() => 0.5 - Math.random());
        setAllProducts(shuffled);
        setVisibleProducts(shuffled.slice(0, 3));
      })
      .catch(error => console.error("Error fetching products:", error));
  }, [clientName]);

  const handleAddToCart = index => {
    if (!cart.includes(index)) {
      setCart([...cart, index]);
    }
  };

  const handleRemoveFromCart = index => {
    setCart(cart.filter(item => item !== index));
  };

  const handleViewMore = () => {
    // Add exactly 3 more products
    setVisibleProducts(allProducts.slice(0, visibleProducts.length + 3));
    setShowMoreButton(false); // Hide the button immediately after click
  };
  const generateRandomId = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from({ length: 4 }, () => characters[Math.floor(Math.random() * characters.length)]).join("");
  };  
  const cartQueryString = cart.map((_, index) => `pid${index + 1}=${generateRandomId()}`).join("&");

  return (
    <> 
    <div className="text-center">
      <div className="row g-2 flex-center align-items-stretch">
        {visibleProducts.map((product, index) => (
          <div 
          key={index} 
          className={`d-flex col-12 col-sm-6 col-md-4 mb-3 mb-sm-0 ${index !== 0 && index !== 1 ? 'hide-in-bill hide-in-pdf' : ''}`}>        
            <div className="reco-product border border-gray overflow-hidden d-flex flex-column w-100" style={{maxWidth:'330px', margin:'0 auto'}}>
              <a className="d-block p-0 move-hover-image cursor-pointer" style={{ backgroundImage: `url("/invoice/client/${clientName}/${product.image}")` }} href={`${websiteUrl}${product.link}`} target="_blank" rel="noopener noreferrer" aria-label={product.title?.[language]}></a>
              <a className="my-2 fw-bold hover-opacity-100 cursor-pointer px-2 flex-center flex-grow-1" style={{ XminHeight:"40px", opacity: "0.85"}}>              
              {product.title?.[language]}</a>
            <div className="hide-in-bill hide-in-pdf text-center d-flex justify-content-between align-items-center bg-theme-dark text-white p-2 hover-bg-black">
            <span className="fw-bold">£ {product.price.toFixed(2)}</span>
            {cart.includes(index) ? (
                  <><span className="text-white fw-bold">
                  {language === "arabic" ? "تمت الإضافة إلى السلة ✓" : language === "german" ? "Zum Warenkorb hinzugefügt ✓" : language === "spanish" ? "Añadido al carrito ✓" : language === "french" ? "Ajouté au panier ✓" : language === "hindi" ? "कार्ट में जोड़ा गया ✓" : "Added to Cart ✓"}
                </span>
                                 <span className="ms-2 text-danger cursor-pointer" onClick={() => handleRemoveFromCart(index)} 
                                 style={{ fontSize: "18px", cursor: "pointer" }}>&#10060;</span>
                                 </>
              ) : (
                <button
                  className="text-white opacity-75 hover-opacity-100 cursor-pointer border-0 bg-transparent"
                  onClick={() => handleAddToCart(index)}
                >
                  {language === "arabic" ? "أضف إلى السلة" : language === "german" ? "In den Warenkorb" : language === "spanish" ? "Añadir al carrito" : language === "french" ? "Ajouter au panier" : language === "hindi" ? "कार्ट में जोड़ें" : "Add to Cart"}
                </button>
              )}
 
            </div>
              <div className="d-none show-in-pdf show-in-bill pb-2"><span className="fw-bold fs-6">£ {product.price.toFixed(2)}</span></div>
            </div>
          </div>
        ))}
      </div>

      {/* View More and View Cart Buttons */}
      <div className=" hide-in-bill hide-in-pdf mt-2 text-end">        
      <button
        className={`d-inline-block Xp-2 border-0 bg-transparent p-0 me-3 mt-1 cursor-pointer ${!showMoreButton ? 'invisible' : ''}`}
        style={{ fontSize: "14px" }}
        onClick={handleViewMore}
      >
{language === "arabic" ? "عرض المزيد من المنتجات &gt;" : language === "german" ? "Mehr Produkte anzeigen >" : language === "spanish" ? "Ver más productos >" : language === "french" ? "Voir plus de produits >" : language === "hindi" ? "अधिक उत्पाद देखें >" : "View More Products >"}
      </button>
      {cart.length > 0 && (
        <a 
          className="btn d-inline-block p-2 cursor-pointer"
          style={{ fontSize: "14px" }}
          target="_blank"
          href={`${websiteUrl}?${cartQueryString}`}
        >
          {language === "arabic" ? `عرض السلة` : language === "german" ? `Warenkorb anzeigen` : language === "spanish" ? `Ver carrito` : language === "french" ? `Voir le panier` : language === "hindi" ? `कार्ट देखें` : `View Cart`} ({cart.length})
        </a>
      )}
      </div>      
    </div>
    <div className="d-none Xshow-in-bill Xshow-in-pdf text-center mt-sm-2" style={{marginTop:'-10px'}}><img src="/img/qr.png" alt="QR Code"/></div>
    </>
  );
};

export default RandomProducts;
